import { AnswerCardTab } from './AnswerCardTab';
export default AnswerCardTab;
